function getFullscreenElement(): Element | null {
  return (
    document.fullscreenElement ??
    (document as Document & { webkitFullscreenElement?: Element }).webkitFullscreenElement ??
    null
  );
}

export function isFullscreenSupported(): boolean {
  return !!(
    document.documentElement.requestFullscreen ||
    (document.documentElement as HTMLElement & { webkitRequestFullscreen?: () => void })
      .webkitRequestFullscreen
  );
}

export function isFullscreen(): boolean {
  return getFullscreenElement() != null;
}

export async function requestFullscreen(element: HTMLElement = document.documentElement): Promise<void> {
  if (element.requestFullscreen) {
    await element.requestFullscreen();
    return;
  }
  const webkit = element as HTMLElement & { webkitRequestFullscreen?: () => void };
  webkit.webkitRequestFullscreen?.();
}

export async function exitFullscreen(): Promise<void> {
  if (document.exitFullscreen) {
    await document.exitFullscreen();
    return;
  }
  const webkitDoc = document as Document & { webkitExitFullscreen?: () => void };
  webkitDoc.webkitExitFullscreen?.();
}

export async function toggleFullscreen(element: HTMLElement = document.documentElement): Promise<void> {
  if (!isFullscreenSupported()) return;
  if (isFullscreen()) {
    await exitFullscreen();
  } else {
    await requestFullscreen(element);
  }
}
